<template>
  <a-modal
    :title="title"
    :visible="open"
    :confirm-loading="submitLoading"
    @ok="submitForm"
    @cancel="cancel"
  >
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="旧密码" prop="oldPassword">
        <a-input-password
          v-model:value="form.oldPassword"
          placeholder="请输入旧密码"
          :maxLength="-1"
        />
      </a-form-model-item>
      <a-form-model-item has-feedback label="新密码" prop="newPassword">
        <a-input-password
          v-model:value="form.newPassword"
          placeholder="请输入新密码"
          :maxLength="-1"
        />
      </a-form-model-item>
      <a-form-model-item has-feedback label="确认密码" prop="confirmPassword">
        <a-input-password
          v-model:value="form.confirmPassword"
          placeholder="请确认密码"
          :maxLength="-1"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateUserPwd } from '@/api/system/user'

export default {
  props: {},
  data() {
    const validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (
        !/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){5,20}$/.test(
          value
        )
      ) {
        callback(
          new Error(
            '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种'
          )
        )
      } else {
        if (this.form.confirmPassword !== '') {
          this.$refs.form.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码确认'))
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      title: '重置密码',
      open: false,
      childrenDrawer: false,
      formLayout: 'horizontal',
      form: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined,
      },
      rules: {
        oldPassword: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, validator: validateNewPass, trigger: 'change' },
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPass, trigger: 'change' },
        ],
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
      },
    }
  },
  mounted() {
    this.reset()
  },
  methods: {
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined,
      }
    },
    handleUpdatePwd() {
      this.open = true
    },
    /** 重置密码按钮操作 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          updateUserPwd(this.form.oldPassword, this.form.newPassword)
            .then((response) => {
              this.$message.success('修改成功', 3)
              this.open = false
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
/* 弹窗按钮样式 - 所有按钮圆角设置为 4px */
:deep(.ant-modal-footer .ant-btn) {
  border-radius: 4px !important;
}

/* 确认按钮（主要按钮）样式 */
:deep(.ant-modal-footer .ant-btn-primary) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
  color: #FFFFFF !important;
}

/* 确认按钮悬停状态 */
:deep(.ant-modal-footer .ant-btn-primary:hover:not(:disabled)) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

/* 确认按钮聚焦状态 */
:deep(.ant-modal-footer .ant-btn-primary:focus:not(:disabled)) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

/* 确认按钮激活状态 */
:deep(.ant-modal-footer .ant-btn-primary:active:not(:disabled)) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

/* 取消按钮（默认按钮）样式 */
:deep(.ant-modal-footer .ant-btn-default) {
  border-radius: 4px !important;
}

/* 输入框圆角样式 */
:deep(.ant-input-password),
:deep(.ant-input-password .ant-input),
:deep(.ant-input-password .ant-input-affix-wrapper) {
  border-radius: 4px !important;
}

:deep(.ant-input-password .ant-input-affix-wrapper-focused) {
  border-radius: 4px !important;
}
</style>

<style>
/* Modal 按钮样式 - 全局样式确保生效 */
.ant-modal-footer .ant-btn {
  border-radius: 4px !important;
}

/* 取消按钮样式 */
.ant-modal-footer .ant-btn-default {
  border-radius: 4px !important;
}

/* 确定按钮样式 */
.ant-modal-footer .ant-btn-primary {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
  color: #FFFFFF !important;
}

.ant-modal-footer .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.ant-modal-footer .ant-btn-primary:focus:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.ant-modal-footer .ant-btn-primary:active:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

/* 输入框圆角样式 - 全局样式确保生效 */
.ant-input-password,
.ant-input-password .ant-input,
.ant-input-password .ant-input-affix-wrapper {
  border-radius: 4px !important;
}

.ant-input-password .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
}
</style>